import { BaseService } from "core/services";
import { FacilityOrderTemplateNewFlowRouteService } from "application/facility-order/services";

class FacilityOrderTemplateNewFlowService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new FacilityOrderTemplateNewFlowRouteService());
    }
}

export default FacilityOrderTemplateNewFlowService;